import { LOGOUT, JOURNAL_ANSWERS } from "../types/types"

const initialState = {
  userAnswers: [],
  partnerAnswers: [],
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      }
    case JOURNAL_ANSWERS:
      return {
        ...state,
        userAnswers: payload.user_answers,
        partnerAnswers: payload.partner_answers,
      }
    default:
      return state
  }
}
